const TiktokIcon = ({
  size = '32',
  fill = '#BEBEBE',
  className = null,
}: React.ComponentProps<'svg'> & { size?: string | number }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 17 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 0V15.4C8.5 16.6431 7.57569 17.6 6.375 17.6C5.17431 17.6 4.25 16.6431 4.25 15.4C4.25 14.1569 5.17431 13.2 6.375 13.2V8.8C2.87944 8.8 0 11.7811 0 15.4C0 19.0189 2.87944 22 6.375 22C9.87056 22 12.75 19.0189 12.75 15.4V7.11133C14.0593 8.07695 15.4256 8.8 17 8.8V4.4C16.8994 4.4 15.4332 3.91806 14.4102 2.99492C13.3871 2.07178 12.75 0.912981 12.75 0H8.5Z"
        fill={fill}
      />
    </svg>
  );
};

export default TiktokIcon;
